import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Drawer, Input, Field, Select } from '@itds/elements/index.js';

import { Api } from '@brokerage/utils/Api';

const EditLink = ({ link, categories, onClose, onSave, show }) => {
  const [data, setData] = useState({});
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    const new_link = link || {};

    setData({
      description: new_link.description || '',
      guid: new_link.guid,
      mobile_app_guid: new_link.mobile_app_guid,
      link_type: new_link.link_type || 'web',
      name: new_link.name || '',
      url: new_link.url || '',
      order: new_link.order || 0,
      category_guid: new_link.category_guid || ''
    });
  }, [link]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleSave = () => {
    const errors = [];
    const required_fields = ['name', 'url'];

    required_fields.forEach(field => {
      if (!data[field]) {
        errors.push(field);
      }
    });

    setErrors(errors);

    if (!errors.length) {
      window.scrollTo(0, 0);

      Api.saveMobileAppResourceLink(data.guid, data).then(() => {
        onSave();
      });
    }
  };

  return (
    <Drawer
      alignRight={true}
      footer={
        <Button onClick={handleSave}>{data.id ? 'Save Changes' : 'Create Resource Link'}</Button>
      }
      onClose={onClose}
      show={show}
      title={data.id ? 'Editing Resource Link' : 'New Resource Link'}
    >
      <Field label='Parent Category'>
        <Select
          onChange={handleInputChange.bind(null, 'category_guid')}
          options={[{ value: '', label: 'Uncategoried' }].concat(
            categories.map(c => {
              return {
                value: c.guid,
                label: c.name
              };
            })
          )}
          value={data.category_guid}
        />
      </Field>

      <Field label='Type'>
        <Select
          onChange={handleInputChange.bind(null, 'link_type')}
          options={[
            { value: 'web', label: 'Web' },
            { value: 'video', label: 'Video' }
          ]}
          value={data.link_type}
        />
      </Field>

      <Field label='Name'>
        <Input
          invalid={errors.includes('name')}
          onChange={handleInputChange.bind(null, 'name')}
          required={true}
          value={data.name}
        />
      </Field>

      <Field label='URL'>
        <Input
          invalid={errors.includes('url')}
          onChange={handleInputChange.bind(null, 'url')}
          required={true}
          value={data.url}
        />
      </Field>

      <Field label='Description'>
        <Input onChange={handleInputChange.bind(null, 'description')} value={data.description} />
      </Field>

      <Field label='Display Order'>
        <Input
          onChange={handleInputChange.bind(null, 'order')}
          step={1}
          type='number'
          value={data.order}
        />
      </Field>
    </Drawer>
  );
};

EditLink.propTypes = {
  categories: PropTypes.array,
  link: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default EditLink;
